function normalizeURL(url) {
  return url
    .toLowerCase()
    .replace('http:', 'https:')
    .replace('www.', '')
    .replace(/\/$/, '');
}

export default function dedupeWebsites(urls) {
  const dupes = {};

  return urls.filter((url) => {
    const normalized = normalizeURL(url);
    const didExist = dupes[normalized] || false;

    dupes[normalized] = true;

    return !didExist;
  });
}
